import React, { useState } from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";

const SystemsRelatedPartiesMainTable = () => {
  const actionsButtons = ["add", "remove", "export", { text: "Add/Edit Loan Officer", action: "add", path: "systems-related-parties/add-edit-loan-officer" }];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="" // TODO: Add loan comments suffix
    sortable={["Created On"]}
  />;
};

const addRelatedPartiesFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Borrower", "", { required: true } )]);
  myForm.addCenteredGroup([myForm.getDropdownField("Special Purpose Entity", "")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan", "", { required: true })]);
  return myForm;
};

const AddRelatedPartiesForm = () => {
  const [isNext, setIsNext] = useState(false);
  const [borSpeLoanData, setBorSpeLoanData] = useState({} as any);
  const myForm = addRelatedPartiesFields(new BCFormController({}, { submitSuffix: "" })); // TODO: Add submit suffix

  const handleNextClick = (data, handleSubmit, useFormInstance) => {
    setIsNext(true);
    setBorSpeLoanData(data);
    if (FeatureFlags.IS_DEBUG) {
      console.log(data, handleSubmit, useFormInstance, borSpeLoanData);
    }
  };

  const formActions = [{ text: "Next", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleNextClick }, "close"];

  const handleAddRelatedEntityClick = (data) => {
    if (FeatureFlags.IS_DEBUG) {
       console.log(data);
    }
  };

  const handleAddGuarantorClick = (data) => {
    if (FeatureFlags.IS_DEBUG) {
      console.log(data);
    }
  };

  const actionsButtons = [
    "export",
    { text: "Add Related Entity", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleAddRelatedEntityClick },
    { text: "Add Guarantor", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleAddGuarantorClick },
  ];

  return <React.Fragment>
    {!isNext && <LmsFormGenerator myForm={myForm} actions={formActions}/>}
    {isNext && <LmsTable
      actionButtons={actionsButtons}
      apiSuffix="" // TODO: Add loan comments suffix
      sortable={["Created On"]}
    />}
  </React.Fragment>;
};

const EditLoanOfficerForm = ({ borSpeLoanData }) => {
  const myForm = new BCFormController({}, { submitSuffix: "" }); // TODO: Add submit suffix
  myForm.addGroupFields([
     myForm.getDisplayField("App #"),
     myForm.getDisplayField("Loan #"),
     myForm.getDisplayField("Primary Borrower Name"),
     myForm.getDisplayField("Partnered Loan"),
     myForm.getDisplayField("Phase"),
     myForm.getDisplayField("Status"),
  ]);
  myForm.addCenteredGroup([myForm.getDropdownField("Name of Loan Officer")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Closing LO")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Payoff LO")]);

  const handleSaveClick = (data, isClose) => {
    if (FeatureFlags.IS_DEBUG) {
       console.log(data, borSpeLoanData, isClose);
    }
  };

  const formActions = [
    { text: "Save", handleClick: (data) => handleSaveClick(data, false) },
    { text: "Save and Close", handleClick: (data) => handleSaveClick(data, true) },
    "close"
  ];

  return <LmsFormGenerator myForm={myForm} actions={formActions}/>;
};

const AddLoanOfficerForm = () => {
  const [isNext, setIsNext] = useState(false);
  const [borSpeLoanData, setBorSpeLoanData] = useState({} as any);
  const myForm = addRelatedPartiesFields(new BCFormController({}, { submitSuffix: "" })); // TODO: Add submit suffix

  const handleNextClick = (data, handleSubmit, useFormInstance) => {
    setIsNext(true);
    setBorSpeLoanData(data);
    if (FeatureFlags.IS_DEBUG) {
      console.log(data, handleSubmit, useFormInstance);
    }
  };

  const formActions = [{ text: "Next", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleNextClick }, "close"];

  return <React.Fragment>
    {!isNext && <LmsFormGenerator myForm={myForm} actions={formActions}/>}
    {isNext && <EditLoanOfficerForm borSpeLoanData={borSpeLoanData}/>}
  </React.Fragment>;
};

const LmsSystemsRelatedParties = ({ params = {}, history }) => {
  const allowedActions = [];
  const allowedSubpages = ["add-edit-loan-officer"];
  const { isMainPage, isAdd, isActionAllowed, isSubpageAllowed, actionLower } = useParseRouteActions(params, allowedActions, allowedSubpages);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <SystemsRelatedPartiesMainTable/>}
    {isAdd && <AddRelatedPartiesForm/>}
    {isSubpageAllowed && <React.Fragment>
      {actionLower === "add-edit-loan-officer" && <AddLoanOfficerForm/>}
        </React.Fragment>}
    </React.Fragment>);
};

export default LmsSystemsRelatedParties;